import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "../../lib/utils";

const alertVariants = cva(
	"relative w-full rounded-lg p-4 text-sm flex items-center [&>svg~*]:pl-3 [&>svg]:text-foreground",
	{
		variants: {
			variant: {
				default: "bg-muted text-foreground text-gray-600",
				info: "border-secondary/25 border text-secondary dark:border-0 dark:bg-stealth-button dark:text-white [&>svg]:text-white bg-gray-50",
				destructive:
					"border-destructive/50 border text-destructive dark:border-0 dark:text-destructive-foreground dark:bg-destructive [&>svg]:text-destructive dark:[&>svg]:text-destructive-foreground",
			},
		},
		defaultVariants: {
			variant: "default",
		},
	},
);

export type AlertVariant = VariantProps<typeof alertVariants>["variant"];

const Alert = React.forwardRef<
	HTMLDivElement,
	React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof alertVariants>
>(({ className, variant, ...props }, ref) => (
	<div ref={ref} role="alert" className={cn(alertVariants({ variant }), className)} {...props} />
));
Alert.displayName = "Alert";

const AlertTitle = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLHeadingElement>>(
	({ className, ...props }, ref) => (
		<h5 ref={ref} className={cn("mb-1 font-medium", className)} {...props} />
	),
);
AlertTitle.displayName = "AlertTitle";

const AlertDescription = React.forwardRef<
	HTMLParagraphElement,
	React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
	<div ref={ref} className={cn("text-sm", className)} {...props} />
));
AlertDescription.displayName = "AlertDescription";

export { Alert, AlertDescription, AlertTitle };
